"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var ScrollTarget = /** @class */ (function (_super) {
    tslib_1.__extends(ScrollTarget, _super);
    function ScrollTarget(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollTarget = null;
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        return _this;
    }
    ScrollTarget.prototype.createRef = function (element) {
        this.scrollTarget = element;
    };
    ScrollTarget.prototype.scrollToTop = function () {
        if (this.shouldScroll()) {
            window.scrollTo(0, this.clientTop + window.scrollY);
        }
    };
    ScrollTarget.prototype.shouldScroll = function () {
        if (this.props.onlyScrollUp) {
            return this.clientTop < 0;
        }
        return true;
    };
    Object.defineProperty(ScrollTarget.prototype, "clientTop", {
        get: function () {
            var _scrollTarget = this.scrollTarget;
            return _scrollTarget.getBoundingClientRect().top + this.props.verticalOffset;
        },
        enumerable: true,
        configurable: true
    });
    ScrollTarget.prototype.render = function () {
        return (React.createElement("div", { className: "offset-anchor-wrapper" },
            React.createElement("div", { className: "offset-anchor scrollTarget", ref: this.createRef })));
    };
    ScrollTarget.defaultProps = {
        verticalOffset: 0
    };
    tslib_1.__decorate([
        bind_1.default
    ], ScrollTarget.prototype, "createRef", null);
    return ScrollTarget;
}(React.Component));
exports.default = ScrollTarget;
//# sourceMappingURL=scroll_target.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/scroll_target.js
// module id = bk3t
// module chunks = 20 21